import createApiThunk from '../../../ApplicationFactory'
import { type ISurveyTemplate } from '../../../models/SurveyTemplate'

export const getStudentSurveyById = createApiThunk<ISurveyTemplate>('getStudentSurveyById', {
  url: '/api/surveys/<urlId>',
  method: 'GET'
})

export const submitStudentSurvey = createApiThunk<ISurveyTemplate>('submitSurvey', {
  url: '/api/surveys/<urlId>',
  method: 'patch'
})

export const getStudentSurveyByIdPublic = createApiThunk<ISurveyTemplate>('getStudentSurveyByIdPublic', {
  url: '/api/surveys/<urlId>/public/',
  method: 'GET'
})

export const submitStudentSurveyPublic = createApiThunk<ISurveyTemplate>('submitStudentSurveyPublic', {
  url: '/api/surveys/<urlId>/public/',
  method: 'patch'
})
